// extracted by mini-css-extract-plugin
export default {"featuredProducts":"FeaturedProducts_featuredProducts__B-cR0","viewProductsButton":"FeaturedProducts_viewProductsButton__ILVzK"};